import * as React from 'react';

interface SettingPopupTabsProps {
  vertical?: boolean;
  initialSelectedTabIndex?: number;
}

interface SettingPopupTabsState {
  selectedTabIndex: number;
  vertical: boolean;
  onClickTab: (tabIndex: number) => void;
}

export const TabsContext = React.createContext<SettingPopupTabsState>({
  selectedTabIndex: 0,
  vertical: false,
  onClickTab: () => {},
});

// TabsContextを提供する枠コンポーネント
// SettingPopupListやSettingPopupTabPanelと組み合わせて使う
class SettingPopupTabs extends React.PureComponent<SettingPopupTabsProps, SettingPopupTabsState> {
  public constructor(props: SettingPopupTabsProps) {
    super(props);

    this.state = {
      selectedTabIndex: props.initialSelectedTabIndex || 0,
      vertical: props.vertical || false,
      onClickTab: this.handleOnClickTab,
    };
  }

  private handleOnClickTab = (selectedTabIndex: number) => {
    this.setState({ selectedTabIndex });
  }

  public render() {
    return (
      <TabsContext.Provider value={this.state}>
        {this.props.children}
      </TabsContext.Provider>
    );
  }
}

export default SettingPopupTabs;
